import styled from 'styled-components';

export const WebcamFrame = styled.div`
  display: block;
  position: relative;
  height: 0;
  padding-bottom: 56%;
  ${({ $disabled }) => $disabled && 'pointer-events: none;'}

  [id^="webcam_holder"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  [id^="webcam_holder"] iframe {
    width: 100% !important;
    height: 100% !important;
    border: 0;
  }

  .webcam-holder {
    position: absolute;
    inset: 0;
  }

  .webcam-holder iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
